export const CorporateActionTypeOptions = [
  { value: 'coupon', label: 'coupon', icon: '' },
  { value: 'dividend', label: 'dividend', icon: '' },
  { value: 'custom', label: 'custom', icon: '' },
];
